@switch (parentFilterValue) {
    @case (listingStatusEnum.LIVE) {
        <div
            class="statusWrapper live"
            title="{{ 'listings.statuses.tooltips.live' | translate }}"
            [ngClass]="{ 'small-icon': isFloatingFilterIcon }"
        >
            <i class="fas fa-check"></i>
        </div>
    }

    @case (listingStatusEnum.DRAFT) {
        <div
            class="statusWrapper draft"
            title="{{ 'listings.statuses.tooltips.draft' | translate }}"
            [ngClass]="{ 'small-icon': isFloatingFilterIcon }"
        >
            <i class="fas fa-pen-to-square"></i>
        </div>
    }

    @case (listingStatusEnum.PUBLISHING_IN_PROGRESS) {
        <div
            class="statusWrapper submitted-publish"
            title="{{ 'listings.statuses.tooltips.publishingInProgress' | translate }}"
            [ngClass]="{ 'small-icon': isFloatingFilterIcon }"
        >
            <i class="fas fa-loader"></i>
        </div>
    }

    @case (listingStatusEnum.APPROVAL) {
        <div
            class="statusWrapper submitted-approval"
            title="{{ 'listings.statuses.tooltips.approval' | translate }}"
            [ngClass]="{ 'small-icon': isFloatingFilterIcon }"
        >
            <i class="fas fa-user-check"></i>
        </div>
    }

    @case (listingStatusEnum.FAILURES) {
        <div
            class="statusWrapper publish-failure"
            title="{{ 'listings.statuses.tooltips.failures' | translate }}"
            [ngClass]="{ 'small-icon': isFloatingFilterIcon }"
        >
            <i class="fas fa-triangle-exclamation"></i>
        </div>
    }

    @case (listingStatusEnum.REJECTED) {
        <div
            class="statusWrapper publish-rejected"
            title="{{ 'listings.statuses.tooltips.rejected' | translate }}"
            [ngClass]="{ 'small-icon': isFloatingFilterIcon }"
        >
            <i class="fas fa-delete-left"></i>
        </div>
    }

    @case (listingStatusEnum.REJECTED_WITH_COMMENTS) {
        <div
            class="statusWrapper publish-comments"
            title="{{ 'listings.statuses.tooltips.comments' | translate }}"
            [ngClass]="{ 'small-icon': isFloatingFilterIcon }"
        >
            <i class="fas fa-comments"></i>
        </div>
    }

    @case (listingStatusEnum.BULK_PROCESSING) {
        <div
            class="statusWrapper bulk-processing"
            title="{{ 'listings.statuses.tooltips.bulkProcessing' | translate }}"
            [ngClass]="{ 'small-icon': isFloatingFilterIcon }"
        >
            <i class="fas fa-layer-group"></i>
        </div>
    }

    @case (listingStatusEnum.NEW) {
        <div class="statusWrapper new" title="{{ 'listings.statuses.new' | translate }}" [ngClass]="{ 'small-icon': isFloatingFilterIcon }">
            <i class="fas fa-sparkles"></i>
        </div>
    }

    @case (null) {
        <div class="statusWrapper unknown" title="Unknown" [ngClass]="{ 'small-icon': isFloatingFilterIcon }">
            <i class="fas fa-question"></i>
        </div>
    }
}

@if (
    isNewListing &&
    [
        listingStatusEnum.DRAFT,
        listingStatusEnum.PUBLISHING_IN_PROGRESS,
        listingStatusEnum.APPROVAL,
        listingStatusEnum.FAILURES,
        listingStatusEnum.REJECTED,
        listingStatusEnum.REJECTED_WITH_COMMENTS,
        listingStatusEnum.BULK_PROCESSING,
    ].includes($any(parentFilterValue))
) {
    <div
        class="statusWrapper new"
        title="{{ 'listings.statuses.tooltips.new' | translate }}"
        [ngClass]="{ 'small-icon': isFloatingFilterIcon, newListing: isNewListing }"
    >
        <i class="fas fa-sparkles"></i>
    </div>
}

@if (isFloatingFilterIcon) {
    {{ 'listings.statuses.' + parentFilterValue | translate }}
}
